module.exports = __webpack_public_path__ + "img/루나블레이드.f0032c9b.png";